import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {ZoneManagement} from './ZoneManagement'

const ZoneManagementWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Zone Management</PageTitle>
      <ZoneManagement />
    </>
  )
}

export default  ZoneManagementWrapper
